import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=4f83274a"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"
import style0 from "./Cell.vue?vue&type=style&index=0&id=4f83274a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports